export default __webpack_public_path__ + "static/media/beer-club-sm.ff8398aa.png";